import useAuthErrorDialog from "@/lib/useAuthErrorDialog"
import { promiseTimeout } from "@vueuse/core"
import axios, { AxiosError, AxiosRequestConfig } from "axios"

const RETRY_DELAY_IN_MS = 4000
interface RetryableAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean
}

const handleAuthErrorInterceptor = async (error: AxiosError) => {
  const originalRequest = error.config as RetryableAxiosRequestConfig
  const isAuthTokenRequired = !originalRequest.url?.startsWith("/api/v1/auth")
  const isRefreshTokenRequest = originalRequest.url?.startsWith(
    "/api/v1/auth/refresh",
  )

  if (
    error.code === AxiosError.ERR_NETWORK &&
    isRefreshTokenRequest &&
    !originalRequest._retry
  ) {
    originalRequest._retry = true
    await promiseTimeout(RETRY_DELAY_IN_MS)
    return axios(originalRequest)
  }

  if (
    error.response &&
    error?.response?.status === 403 &&
    isAuthTokenRequired
  ) {
    useAuthErrorDialog().showDialog()
  }

  return Promise.reject(error)
}

export default handleAuthErrorInterceptor
